import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { keys } from "./keys";

type Variables = {
  id: string;
  source: 'action' | 'event';
  fromSubTopicId: string;
  toSubTopicId: string;
};

async function moveHistoryItem(variables: Variables) {
  const { id, source, fromSubTopicId, toSubTopicId } = variables;

  if (fromSubTopicId === toSubTopicId) {
    throw new Error('Source and target sub-topics must be different.');
  }

  const table = source === 'event' ? 'events' : 'subject_actions';

  const { error } = await apiClient
    .from(table)
    .update({ subject_id: toSubTopicId })
    .eq('id', id);

  if (error) throw error;

  // Keep linked documents' sub_topic_id consistent with the new owner.
  const docFkColumn = source === 'event' ? 'event_id' : 'subject_action_id';
  const { error: docsError } = await apiClient
    .from('documents')
    .update({ sub_topic_id: toSubTopicId })
    .eq(docFkColumn, id);

  if (docsError) throw docsError;
}

export function useMoveHistoryItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: moveHistoryItem,
    onSuccess: (_, { fromSubTopicId, toSubTopicId }) => {
      enqueueSnackbar('Élément déplacé.', 'success');
      queryClient.invalidateQueries({ queryKey: keys.subTopic(fromSubTopicId) });
      queryClient.invalidateQueries({ queryKey: keys.subTopic(toSubTopicId) });
      queryClient.invalidateQueries({ queryKey: [...keys.all, 'activityTimeline'] });
    }
  });
}
